import { createTheme } from "@xcira/components";

declare module "@mui/material/styles" {
  interface Sizes {
    [key: string]: string | number;
  }

  interface Grids {
    inventory: string;
  }

  interface Shape {
    borderRadius: number;
  }

  interface Theme {
    sizes: Sizes;
    grids: Grids;
    shape: Shape;
  }

  interface ThemeOptions {
    sizes: Sizes;
    grids: Grids;
    shape: Shape;
  }
}

const black = "#222222";
const gray5 = "#3F3F3F";
const gray4 = "#767676";
const gray3 = "#999999";
const gray2 = "#CCCCCC";
const gray1 = "#F0F0F0";
const gray0 = "#F7F7F7";
// const purple = "#551A8B";
const rbBlue = "#003A70";
const blue = "#005B99";
const blue3 = "#B7D5E5";
const blue2 = "#D2ECFA";
const blue1 = "#ECF5FB";
const red = "#E50000";
const red2 = "#F2C7C1";
const red1 = "#FDDDD9";
const rbOrange = "#E87511";
const darkOrange = "#B24F00";
const lightOrange = "#FCEFE4";
const yellow = "#FACE53";
const yellow2 = "#F2E0A9";
const yellow1 = "#FCF0D4";
const green = "#11AF00";
const green2 = "#C3E5C5";
const green1 = "#DBF3DD";

export const theme = createTheme({
  shape: {
    borderRadius: 5,
  },
  spacing: 8,
  typography: {
    fontFamily: "Roboto",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1367,
      xl: 1920,
    },
  },
  palette: {
    common: {
      black: black,
    },
    background: {
      default: "#FFFFFF",
    },
    text: {
      primary: black,
      secondary: gray4,
      disabled: gray3,
    },
    grey: {
      50: gray0,
      100: gray0,
      200: gray1,
      400: gray2,
      500: gray3,
      600: gray4,
      700: gray5,
    },
    primary: {
      main: blue,
      dark: rbBlue,
    },
    secondary: {
      light: lightOrange,
      main: rbOrange,
      dark: darkOrange,
    },
    error: {
      light: red1,
      main: red,
      dark: red2,
    },
    warning: {
      light: yellow1,
      main: yellow,
      dark: yellow2,
    },
    info: {
      light: blue1,
      main: blue2,
      dark: blue3,
    },
    success: {
      light: green1,
      main: green,
      dark: green2,
    },
  },
  sizes: {
    globalHeader: "7.8rem",
    globalHeaderMobile: "10rem",
    mainHeight: "1fr",
    mobileBidBox: "17rem",
  },
  grids: {
    inventory:
      "50px" + // Lot Number
      " 125px" + // Review Status
      " 175px" + // Review Actions
      " minmax(150px, 1fr)" + // Lot Description
      " 100px" + // Status
      " 200px" + // Sold To
      " 150px" + // Sold Amount
      " 50px", // Photo
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          alignItems: "center",
          paddingLeft: 16,
          paddingRight: 16,
        },
        indicator: {
          display: "none",
        },
        centered: {
          "& > :first-of-type": {
            borderRadius: "5px 0px 0px 5px",
          },
          "& > :last-of-type": {
            borderRadius: "0px 5px 5px 0px",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          border: `1px solid ${gray2}`,
          borderRadius: 0,
          minWidth: 64,
          minHeight: 24,
          padding: 0,
          color: black,
          "&.Mui-selected": {
            color: darkOrange,
            background: lightOrange,
            border: `2px solid ${rbOrange}`,
          },
        },
        textColorInherit: {
          opacity: 1,
        },
      },
    },
  },
});
